import { SWEEP_OPTIONS_CODES, SWEEP_OPTIONS_NAMES, SWEEP_OPTIONS_INFO } from 'consts/deal';
import { DealType, SweepOptions } from 'components/common/types/Deal.types';

const getParsedSweepOptions = () => {
  const result = {};

  Object.keys(SweepOptions).forEach((option) => {
    result[option] = {
      name: SWEEP_OPTIONS_NAMES[option],
      code: SWEEP_OPTIONS_CODES[option],
      info: SWEEP_OPTIONS_INFO[option],
    };
  });

  return result;
};

const sweepOptions = getParsedSweepOptions();

export const getSweepOptions = () => {
  const options = { ...sweepOptions };

  delete options[SweepOptions.NONE];
  delete options[SweepOptions.SWEEP_TO_DAYPART];
  delete options[SweepOptions.SWEEP_FLOOR_TO_CEILING_RANGE];

  return options;
};

export const getDefaultSweep = (dealType, hasNonGuaranteedExtendedTargetEnabled) =>
  dealType === DealType.GUARANTEED || hasNonGuaranteedExtendedTargetEnabled ? SweepOptions.SWEEP_TO_FILL : '';
